import type { GlassCardSpan } from '../types';

import './_glassCardHeader.scss';
import clsx from 'clsx';
import type { ReactNode } from 'react';

/** Props for the GlassCardHeader (header/divider slot in the card grid). */
export interface GlassCardHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  span?: GlassCardSpan;
  className?: string;
  /** When true, the element is visually hidden but still occupies its layout space — use to balance a visible header. */
  invisible?: boolean;
}

/**
 * A header/divider block that can be slotted into GlassCardGrid like a card.
 * Has distinct styling from full cards and functions as a visual divider
 * (e.g. top title, or section headers between cards).
 */
export function GlassCardHeader({ title, subtitle, span = 12, className, invisible = false }: GlassCardHeaderProps) {
  return (
    <div
      className={clsx('glass-card-header', `glass-card-header--span-${span}`, { 'glass-card-header--invisible': invisible }, className)}
      role="presentation"
      aria-hidden={invisible || undefined}
    >
      <div className="glass-card-header__title">{title}</div>
      {subtitle && <div className="glass-card-header__subtitle">{subtitle}</div>}
    </div>
  );
}
